import React from 'react';
import {
	Dialog,
	DialogContent,
	Grid2,
	Typography,
	IconButton as MaterialIconButton,
	Button,
	Checkbox,
	FormControlLabel,
	Select,
	MenuItem,
} from '@mui/material';
import { CloseIcon } from '../assets/icons/Icons';
import { USER_TYPES } from '../Utils/Enums';
import { UserData } from '../types';

interface UserControlPopupProps {
	isModalOpen: boolean;
	onClose: () => void;
	onClickBtn: () => void;
	selectedUser: UserData;
	onChangeUserType: (value: string) => void;
	accTypeError: { status: boolean; msg: string };
	isButtonDisabled?: boolean;
}

function UserControlPopup({
	isModalOpen,
	onClose,
	onClickBtn,
	selectedUser,
	onChangeUserType,
	accTypeError,
	isButtonDisabled = false,
}: UserControlPopupProps) {
	function renderDialogContent() {
		return (
			<Grid2 container width={'100%'} paddingX={'15px'}>
				<Typography
					fontSize={'16px'}
					paddingY={'10px'}
					fontWeight={'500'}>
					{`Username: ${selectedUser.name}`}
				</Typography>
				<Grid2 container width={'100%'} paddingY={'10px'}>
					<Typography
						fontSize={'16px'}
						width={'100%'}
						color={'#7C7C7C'}
						fontWeight={'500'}
						marginBottom={'5px'}>
						User Type
					</Typography>
					<Select
						size="small"
						fullWidth
						value={selectedUser.userType}
						error={accTypeError?.status}
						renderValue={value => {
							if (!value) {
								return (
									<Typography color="#cacdd4">
										Select User Type
									</Typography>
								);
							}
							return value;
						}}
						onChange={e => {
							onChangeUserType(e.target.value);
						}}
						sx={{
							backgroundColor: '#FFFFFF',
							color: '#777E90',
							marginTop: '5px',
						}}>
						{USER_TYPES.map((item, index) => {
							return (
								<MenuItem key={index} value={item.name}>
									{item.name}
								</MenuItem>
							);
						})}
					</Select>
				</Grid2>
			</Grid2>
		);
	}

	return (
		<>
			<Dialog
				fullWidth
				maxWidth="sm"
				open={isModalOpen}
				onClose={onClose}
				scroll="body">
				<DialogContent style={{ padding: '0px 0px 20px 0px' }}>
					<Grid2
						container
						sx={{ boxShadow: 3 }}
						padding={'10px'}
						flexDirection={'row'}
						justifyContent={'space-between'}
						alignItems={'center'}>
						<Typography fontWeight={'600'}>
							Update User Controls
						</Typography>
						<MaterialIconButton
							style={{ padding: '0' }}
							onClick={onClose}>
							<CloseIcon />
						</MaterialIconButton>
					</Grid2>
					<Grid2 container padding={'10px'}>
						{renderDialogContent()}
					</Grid2>
					<Grid2
						container
						justifyContent={'flex-end'}
						paddingTop={'10px'}
						paddingX={'20px'}>
						<Button
							onClick={onClose}
							sx={{
								border: '2px solid #28696D',
								paddingLeft: '15px',
								paddingRight: '15px',
								color: '#28696D',
								textTransform: 'none',
								marginRight: '8px',
							}}>
							{'Cancel'}
						</Button>
						<Button
							variant="contained"
							disabled={isButtonDisabled}
							style={{
								backgroundColor: '#28696D',
								boxShadow: 'none',
								textTransform: 'none',
							}}
							onClick={onClickBtn}>
							Update
						</Button>
					</Grid2>
				</DialogContent>
			</Dialog>
		</>
	);
}

export default UserControlPopup;
